var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"travel-notes-detail"},[_c('travel-notes-info'),_c('div',{staticClass:"container"},[_c('promo-cruise'),_c('email-share-in-detail')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }